import store from '@/store'

export default (to, from, next) => {
    if (!store.getters.payment_methods_subscribed) {
        return { allow: true }
    }

    return {
        allow: store.getters.has_payment_cards_or_parent_billing_routes,
        redirect: { name: 'no-payment-methods' },
    }
}
